import { FC, memo, ReactNode } from "react";

import { css } from "@emotion/react";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import CopyToClipboard from "@hl/communities-app/lib/components/CopyToClipboard";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { Button } from "@mantine/core";

import { ModalType, updateModalVar } from "~/features/layout/Modal/modal";

import { useAuth } from "../../auth/context";

type OpenEmbedModalProps = {
  baseText?: ReactNode;
  pageSlug: string;
};

const OpenEmbedModal: FC<OpenEmbedModalProps> = ({ baseText, pageSlug }) => {
  const embedShowModal = useFeatureFlags(FEATURE_FLAGS.EMBEDS_SHOW_MODAL);
  const { authenticated } = useAuth();

  const openEmbedModal = () => {
    if (authenticated && embedShowModal) {
      updateModalVar({
        showModal: ModalType.EMBED_GATE_PAGE,
        data: { pageSlug },
      });
    }
  };

  return authenticated && embedShowModal ? (
    <Button color={SECONDARY_COLOR} onClick={openEmbedModal} px="sm">
      {baseText}
    </Button>
  ) : null;
};

const PreviewColumnNavigation = ({
  pageUrl,
  pageSlug,
  editMode,
}: {
  pageUrl: string;
  pageSlug: string;
  editMode: boolean;
}) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
      `}
    >
      <Button color={SECONDARY_COLOR} px="sm">
        <CopyToClipboard
          extraCss={{ padding: 0 }}
          baseText="Copy link"
          copiedText="Copied!"
          toCopy={pageUrl}
        />
      </Button>
      {editMode && (
        <OpenEmbedModal baseText={"Embed page"} pageSlug={pageSlug} />
      )}
    </div>
  );
};

export default memo(PreviewColumnNavigation);
